var Maps = function () {

    var $elements = {}

    var setElements = function () {
        $elements = {
            mapBase: $('#js-map-base'),
            mapBranches: $('#js-branches-map')
        }
    };

    var loadJS = function () {
        // z důvodu špatné detekce typu UL.getScript() se musí použít $
        $.getScript("https://maps.googleapis.com/maps/api/js?key=" + config.googleApiKey, initMaps);
    };

    var initMaps = function () {
        baseMap();
        branchesMap();
    };

    var baseMap = function () {
        if ($elements.mapBase.length) {
            var data = $elements.mapBase.data();

            // var place = {
            //     lat: parseFloat(data.lat),
            //     lng: parseFloat(data.lng)
            // };

			var place = new google.maps.LatLng(parseFloat(data.lat), parseFloat(data.lng));

            var map = new google.maps.Map($elements.mapBase.get(0), {
                zoom: parseInt(data.zoom),
                center: place,
                scrollwheel: false,
                streetViewControl: false,
                mapTypeControl: false
            });

            var marker = new google.maps.Marker({
                position: place,
                map: map,
                icon: config.basePathImg + 'marker.png',
            });
        }
    };

    var branchesMap = function () {
        if ($elements.mapBranches.length) {

            var branches = [];

            // pole pro pobočky
            $elements.mapBranches.eq(0).find('.js-map-marker').each(function () {
                branches.push({
                    position: {
                        lat: parseFloat($(this).data('lat')),
                        lng: parseFloat($(this).data('lng')),
                    },
                    content: $(this).html()
                });
				// branches.push(new google.maps.LatLng(parseFloat($(this).data('lat')), parseFloat($(this).data('lng'))));
            });

            // init mapy
            var data = $elements.mapBranches.data();

            // var center = {
            //     lat: parseFloat(data.lat),
            //     lng: parseFloat(data.lng)
            // };

			var center = new google.maps.LatLng(parseFloat(data.lat), parseFloat(data.lng));

            // if ($(window).width() < 600) {
            //     data.zoom = parseInt(data.zoom) - 1;
            // }

            var map = new google.maps.Map($elements.mapBranches.get(0), {
                zoom: $(window).width() < 600 ? (parseInt(data.zoom) - 1) : parseInt(data.zoom),
                center: center,
                scrollwheel: !feature.touch,
                streetViewControl: false,
                mapTypeControl: false
            });

            // vytvoření markerů
            var lastOpenWindow = false;
            $.each(branches, function (key, value) {

                var marker = new google.maps.Marker({
                    position: value.position,
                    map: map,
                    icon: config.basePathImg + 'marker.png',
                });

                marker.info = new google.maps.InfoWindow({
                    content: value.content
                });

                google.maps.event.addListener(marker, 'click', function () {
                    if (lastOpenWindow) {
                        lastOpenWindow.close();
                    }
                    marker.info.open(map, marker);
                    lastOpenWindow = marker.info;
                });

                google.maps.event.addListener(map, 'click', function(event) {
                    if (lastOpenWindow) {
                        lastOpenWindow.close();
                        lastOpenWindow = false;
                    }
                });

                google.maps.event.addListener(marker, 'dblclick', function(){
                    map.panTo(this.getPosition());
                    map.setZoom(20);
                })
            });
        }
    }

    var test = function () {
        if ($elements.mapBase.length || $elements.mapBranches.length) {
            return true
        } else {
            return false;
        }
    };

    var init = function () {
        setElements();

        if (test()) {
            loadJS();
        }
    };

    return {
        init: init
    };
}();

UL.register(Maps);
